"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShortFlexCSSPropertyValidator = void 0;
var _ShortMergeRequest = require("../ShortMergeRequest");
var _expandCSSToRN = _interopRequireDefault(require("./expandCSSToRN"));
var _ShortCSSPropertyValidator = require("./ShortCSSPropertyValidator");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Flex shorthand property in CSS and React Native differ significantly. This
 * validator must therefore expand this shorthand in a way consistent with the
 * specs for both platforms (native and CSS).
 */
var ShortFlexCSSPropertyValidator = /*#__PURE__*/function (_ShortCSSPropertyVali) {
  _inherits(ShortFlexCSSPropertyValidator, _ShortCSSPropertyVali);
  var _super = _createSuper(ShortFlexCSSPropertyValidator);
  function ShortFlexCSSPropertyValidator(params) {
    _classCallCheck(this, ShortFlexCSSPropertyValidator);
    return _super.call(this, _objectSpread(_objectSpread({}, params), {}, {
      propertyName: 'flex'
    }));
  }
  _createClass(ShortFlexCSSPropertyValidator, [{
    key: "normalizeInlineCSSValue",
    value: function normalizeInlineCSSValue(value) {
      return new _ShortMergeRequest.ShortMergeRequest((0, _expandCSSToRN.default)(this.propertyName, value));
    }
    /**
     * In React Native, "flex" is not a shorthand property, although it looks
     * like one. There is not always a tuple of (flexGrow, flexShrink,
     * flexBasis) that maps exactly to one single "flex" value.
     *
     * For this very reason, it is ill-advised to use "flex" shorthand property.
     * Use the longhand equivalent when that is possible.
     *
     * @param value
     */
  }, {
    key: "normalizeNativeValue",
    value: function normalizeNativeValue(value) {
      return value;
    }
  }]);
  return ShortFlexCSSPropertyValidator;
}(_ShortCSSPropertyValidator.ShortCSSPropertyValidator);
exports.ShortFlexCSSPropertyValidator = ShortFlexCSSPropertyValidator;